import { Dictionary } from '@/types/general'
import { Permission } from '@/store/share/types'

// mutations
export const SET_USERS = 'Set user data'
export const SET_PEERS = 'Set peer data'
// actions
export const USER_LOAD = 'Load users'
export const PEER_LOAD = 'Load peers'
export const PEER_GRANT = 'Grant peer access'
export const PEER_REVOKE = 'Revoke peer access'

export const PERMISSIONS: Dictionary<Permission> = {
    private: {
        name: 'private',
        icon: 'eye-slash',
        position: 4
    },
    creator: {
        name: 'creator',
        icon: 'bolt',
        position: 3
    },
    manage: {
        name: 'manage',
        icon: 'users',
        position: 2
    },
    modify: {
        name: 'modify',
        icon: 'pencil',
        position: 1
    },
    read: {
        name: 'read',
        icon: 'eye',
        position: 0
    }
}
